angular.module('resourceCenterStockModule').service('stockApiService', [
    '$window',
    'trsHttpService',
    '$q',
    function($window, trsHttpService, $q) {
        let commonParams = {};

        return {
            getChannels: requestData,
            getChannelsParams: getChannelsParams,
            getDocList: requestData, // 查询渠道下的稿件列表
            getDocListParams: getDocListParams, // 获取查询渠道稿件的参数
            getGongGaoTenantIdParam: getGongGaoTenantIdParam, // 获取当前环境的新疆日报的租户ID
            getGongGaoTenantId: requestData, // 获取供稿租户ID
            getThemeType: requestData, // 获取所有主题类型
            getThemeTypeParams: getThemeTypeParams, // 获取主题类型的参数
            getArea: requestData, // 获取地域信息
            getAreaParams: getAreaParams, // 获取地域信息的参数
            getProductParams: getProductParams, // 获取产品列表的参数
            getProduct: requestData, // 获取渠道下产品列表
            getReprintCountsParams: getReprintCountsParams, // 获取文章转载量的参数
            getReprintCounts: requestData, // 获取文章转载量的参数
            getListFlagParams: getListFlagParams, // 获取列表页取签见撤重标识参数
            getListFlag: requestData, // 获取列表页取签见撤重标识
            getListImgParams: getListImgParams, // 获取列表页图片的参数
            getListImg: requestData, // 获取列表页图片
            getDetailParams: getDetailParams, // 获取详情页数据的参数
            getDetail: requestData, // 获取详情页数据
            getTakeDocParams: getTakeDocParams, // 获取取稿参数
            getCollectParams: getCollectParams, // 获取收藏参数
            collect: requestData, // 收藏稿件
            geAddPersonalMaterialParams: geAddPersonalMaterialParams, // 获取添加到个人素材的参数
            addToPersonalMaterial: requestData, // 收藏稿件
            getSzbBmListParams: getSzbBmListParams, // 获取数字报版面图列表数据的参数
            getSzbBmList: requestData, // 获取数字报版面图列表数据
            historyMinDate: $window.moment('1936-01-01') // 新疆日报历史稿库时间跨度
        };

        /**
         * [getChannelsParams 获取成品资源库渠道列表]
         *
         * @return  {[type]}  [return description]
         */
        function getChannelsParams(){
            return {
                modelid: 'getProductRoot',
                serviceid: 'navigation',
                typeid: 'zyzx',
            };
        }

        /**
         * [getDocListParams 获取查询渠道稿件的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getDocListParams(){
            return {
                serviceid: 'jtcpg',
                typeid: 'zyzx',
                modelId: 'findFromNavigation',
                fcode: '',
                pageSize: '',
                pageNum: '',
                media_id: '',
                tenantId: '',
                keyword: {
                    searchType: '0', // 查询类型
                    keywords: '', // 关键词
                    time: '', // 时间范围
                    area: '', // 地域
                    zyzxfield: '', // 主题
                    isOriginal: '', // 是否原创
                    isHead: '', // 是否头版
                    isRead: '', // 是否10w+
                    menuscriptType: '', // 稿件类型
                    docType: '1;2;4;7;12' // 稿件类型
                }
            };
        }

        /**
         * [getThemeTypeParams 获取成品资源主题类型的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getThemeTypeParams(){
            return {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                parentId: '-1',
                level: '2',
                excludeId: '-1',
                containParent: false,
                channelName: 'jtcpg',
                typeName: 'zyzxfield'
            };
        }

        /**
         * [getAreaParams 获取地域的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getAreaParams(){
            return {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'base',
                typeName: 'area',
                containParent: 'false',
                level: '1',
                channelName: '-1',
                parentId: '',
                excludeId: '-1',
            };
        }

        /**
         * [getProductParams 获取产品列表的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getProductParams(){
            return {
                serviceid: 'navigation',
                typeid: 'zyzx',
                modelid: 'getProductMedia',
                fcode: '',
                tenantId: '',
            };
        }

        /**
         * [getDocListParams 查询被供稿的租户ID]
         *
         * @return  {[type]}  [return description]
         */
        function getGongGaoTenantIdParam(){
            return {
                serviceid: 'mlf_tenant',
                methodName: 'getGongGaoTenantId',
                httpMethod: 'get',
                dataSource: 'wcm',
            };

        }

        /**
         * [getReprintCountsParams 获取文章转载量的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getReprintCountsParams(){
            return {
                typeid: 'zyzx',
                serviceid: 'jtcpg',
                modelId: 'findReprintCounts',
                tags: '',
            };
        }

        /**
         * [getListFlagParam 获取稿件列表取签见撤重标识的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getListFlagParams(){
            return {
                methodname: 'queryFlag',
                serviceid: 'mlf_bigdataexchange',
                guids: '',
                dataSource: 'wcm',
            };
        }

        /**
         * [getListFlagParam 获取稿件列表图片的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getListImgParams(){
            return {
                typeid: 'zyzx',
                modelid: 'getImgList',
                serviceid: '',
                channelName: '',
                guids: '',
            };
        }

        /**
         * [getDetailParams 获取详情页数据的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getDetailParams(){
            return {
                serviceid: '',
                modelid: 'detailData',
                channelName: '',
                guid: '',
                typeid: 'zyzx',
            };
        }

        /**
         * [getTakeDocParams 取稿的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getTakeDocParams(){
            return {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: '',
                indexname: '',
                channelName: '',
            };
        }

        /**
         * [getCollectParams 收藏稿件的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getCollectParams(){
            return {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: '',
                indexname: '',
                channelName: '',
                dataSource: 'wcm',
            };
        }

        /**
         * [geAddPersonalMaterialParams 稿件添加到个人素材的参数]
         *
         * @return  {[type]}  [return description]
         */
        function geAddPersonalMaterialParams(){
            return {
                typeid: 'zyzx',
                serviceid: 'mlf_bigdataexchange',
                methodname: 'batchPersonalMaterial',
                PersonalMaterialId: 0, // 所属文件夹ID，默认根节点（0）
                channelName: '', 
                indexName: '',
                guid: '',
                dataSource: 'wcm',
            };
        }

        /**
         * [getSzbBmListParams 获取数字报版面图列表数据的参数]
         *
         * @return  {[type]}  [return description]
         */
        function getSzbBmListParams(){
            return {
                serviceid: 'epaper',
                typeId: 'zyzx',
                modelid: 'getBmList',
                dataUser: '',
                pageSize: 12,
                pageNum: '',
                keyword: '',
            };
        }
        
        /**
         * [dealParams 公共的参数适配方法]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function dealParams(params){
            return params;
        }
        
        /**
         * [dealData 适配响应数据]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function dealData(data){
            return data;
        }

        /**
         * [requestData 统一的请求方法，默认请求方法]
         *
         * @param   {[type]}  params  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function requestData(params){
            let deffer = $q.defer();
            let requestParams = angular.extend({}, commonParams, dealParams(params));
            let dataSource = requestParams.dataSource ? requestParams.dataSource : 'bigData';
            let httpMethod = requestParams.httpMethod ? requestParams.httpMethod : 'post';
            if (requestParams.dataSource){
                delete requestParams.dataSource;
            }
            if (requestParams.httpMethod) {
                delete requestParams.httpMethod;
            }
            
            let url = dataSource === 'bigData' ? trsHttpService.getBigDataRootUrl() : trsHttpService.getWCMRootUrl();
            trsHttpService.httpServer(url, requestParams, httpMethod).then(function(data){
                let result = dealData(data);
                deffer.resolve(result);
            }, function(data){
                deffer.reject(data);
            });
            return deffer.promise;
        }


    },
]);
